import type { TBulkAction } from '@/shared/model';
import { BULK_ACTION_ENUM } from '@/shared/model';

/**
 * Builds the bulk-action menu offered above the beat template grid, each entry carrying its number hotkey. Lists the do-nothing, N, S, V and Q reclassification and delete-all entries, inserts the swap-the-template entry only in template mode, and always appends mark-as-reviewed.
 *
 * @param isTemplate - True when the grid shows beat templates, which adds the swap-the-template entry.
 * @returns The ordered menu entries with their labels, bulk action values and hotkeys.
 */
const getBulkActionMenu = (isTemplate?: boolean) => {
  const menu: { label: string; value: TBulkAction; hotkey: string }[] = [
    {
      label: 'Do nothing',
      value: BULK_ACTION_ENUM.NOTHING,
      hotkey: '1',
    },
    {
      label: 'Change all to N beat',
      value: BULK_ACTION_ENUM.ALL_N,
      hotkey: '2',
    },
    {
      label: 'Change all to S beat',
      value: BULK_ACTION_ENUM.ALL_S,
      hotkey: '3',
    },
    {
      label: 'Change all to V beat',
      value: BULK_ACTION_ENUM.ALL_V,
      hotkey: '4',
    },
    {
      label: 'Change all to Q beat',
      value: BULK_ACTION_ENUM.ALL_Q,
      hotkey: '5',
    },
    {
      label: 'Delete all beats',
      value: BULK_ACTION_ENUM.ALL_DELETE,
      hotkey: '6',
    },
  ];
  if (isTemplate) {
    menu.push({
      label: 'Swap the template',
      value: BULK_ACTION_ENUM.SWAP_TEMPLATE,
      hotkey: '7',
    });
  }

  menu.push({
    label: 'Mark as reviewed',
    value: BULK_ACTION_ENUM.MARK_REVIEWED,
    hotkey: '8',
  });
  return menu;
};

export default getBulkActionMenu;
